/*
Developed by Dr. Khaled Huthaily - Copyright 2015
You are not allowed to copy or use any of the codes below without a written
permission from the developer: huthaily.com
*/

import {
    formatAMPM
} from './common.js';

$(() => {
    let locale = ($('html').attr('lang')).trim();
    let lang = require(`./lang/bees/${locale}.json`);

    function resetTable() {
        $('#results-head').html(`<tr class="text-muted text-center small">
            <th scope="col">${lang.no_results}</th>
        </tr>`);

        $('#results-body').html('');

        $('#clear-bees-results').attr('disabled', true);
    };

    let resultCounter = localStorage.getItem('result_counter') ?? 0;
    localStorage.setItem('result_counter', resultCounter);

    if (resultCounter > 0) {
        $('#results-head').html(`<tr class="text-muted small">
            <th scope="col">${lang.number}</th>
            <th scope="col" class="text-center">${lang.level}</th>
            <th scope="col" class="text-center" title="${lang.total_bees}">${lang.bees}</th>
            <th scope="col" class="text-end" title="${lang.date_format}">${lang.date}/${lang.time}</th>
        </tr>`);

        for (let i = 1; i <= resultCounter; i++) {
            let result = JSON.parse(localStorage.getItem(`result_${i}`));

            if (result) {
                $('#results-body').append(`
                    <tr>
                        <td>${result.number}.</td>
                        <td class="text-center"><span class="fw-bold">${result.level}</span></td>
                        <td class="text-center">${result.bees}</td>
                        <td class="text-end">${result.date}</td>
                    </tr>`);
            }
        }
    } else {
        resetTable();
    };

    $('#clear-bees-results').on('click', function(e) {
        for (let i = 1; i <= resultCounter; i++) {
            localStorage.removeItem(`result_${i}`);
        };

        resultCounter = 0;

        localStorage.setItem('result_counter', resultCounter);

        resetTable();
    });


    let isTouchScreen = () => {
        return ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
    };

    if (isTouchScreen()) {
        $('#touch-screen-forward').text(lang.press_to_fly);
        $('#touch-screen-btns').removeClass('d-none');
    };

    // Function to Set Highest Level in a Cookie
    // function setCookie(value) {
    //     document.cookie = `highest_score=${value}; Secure`;
    // }

    var resetKeys = false;

    // let highestScore = document.cookie.split('; ').find((row) => row.startsWith('highest_score'))?.split('=')[1];

    // if (highestScore) {
    //     // Get Cookie (add if statement to see if cookie exists or not; if not, make the value "N/A" or 0
    //     document.getElementById('highestLevel').innerHTML = highestScore;
    // }

    let attempt = 1;
    let maxAttempt = 3;
    let level = 1;

    let soundStatus = localStorage.getItem('sound');

    if (soundStatus == null) { // not set yet
        soundStatus = true;
        localStorage.setItem('sound', soundStatus);
    };

    if (soundStatus === 'false') {
        soundStatus = false;
    };

    $('#sound').prop('checked', soundStatus);

    $('#sound').on('change', function(e) {
        soundStatus = $(this).prop('checked');
        localStorage.setItem('sound', soundStatus);
    });

    // Elements
    let spiders = [
        {
            x: 150,
            y: 50,
            speedY: 1,
            w: 48,
            h: 48
        },
        {
            x: 350,
            y: 50,
            speedY: 1.5,
            w: 48,
            h: 48
        },
        {
            x: 550,
            y: 50,
            speedY: 2,
            w: 48,
            h: 48
        },
        {
            x: 730,
            y: 50,
            speedY: 2.5,
            w: 48,
            h: 48
        }
    ];

    let bee = {
        x: 30,
        y: 240,
        speedX: 4,
        w: 48,
        h: 48,
        isMoving: false
    };

    // Goal Object
    let goal = {
        x: 850,
        y: 188,
        w: 10,
        h: 246
    };

    // Constants
    const GAME_WIDTH = 1000;
    const GAME_HEIGHT = 500;

    let gameLive = true; // Keep the game going

    let audioApi = {};

    let color = document.getElementById("color");

    color.className = 'green';

    let sprites = {};

    let moveBee = function() { // make bee move
        if (soundStatus == 'true' || soundStatus == true) {
            audioApi = new Audio();
            audioApi.autoplay = true;
            audioApi.src = '../audio/bees/empty.mp3'; // approach to fix audio on iOS devices
        } else {
            audioApi = {};
        };

        bee.isMoving = true;
    };

    let stopBee = function() { // make bee stop
        bee.isMoving = false;
    };

    let canvas = document.getElementById('myCanvas'); // capture canvas
    let ctx = canvas.getContext ('2d'); // define context

    canvas.addEventListener('mousedown', moveBee); // add event listener to move bee
    canvas.addEventListener('mouseup', stopBee);

    // canvas.addEventListener('touchstart', moveBee); // touch-screen support
    // canvas.addEventListener('touchend', stopBee);

    document.onkeydown = function(e) {
        if (resetKeys === false) {
            if (e.key == " " || e.code == "Space" || e.keyCode == 32 || e.keyCode == 39 || e.keyCode == 40 || e.keyCode == 68) {
                moveBee();
            } else if (e.keyCode == 37) { // move back
                if (bee.x > 30 && bee.x < 890) {
                    bee.x = bee.x - 5;
                }
            }
        };

        if (e.keyCode == 13) { // enter closes game over modal
            if ($('#game-over-modal').hasClass('show')) {
                window.location = ''; // Reolad page
            };
        };
    };

    document.onkeyup = function(e) {
        resetKeys = false;
        if (e.key == " " || e.code == "Space" || e.keyCode == 32 || e.keyCode == 39 || e.keyCode == 40 || e.keyCode == 68) {
            stopBee();
        };
    };

    $('#touch-screen-forward')
        .on('touchstart', function(e) {
            e.preventDefault();
            moveBee();
            $('#touch-screen-forward').text(lang.release);
        }).on('touchend', function(e) {
            moveBee();
            $('#touch-screen-forward').text(lang.release);stopBee();
            $('#touch-screen-forward').text(lang.press_to_fly);
        });

    $('#touch-screen-back-up')
        .on('touchstart', function(e) {
            e.preventDefault();
            if (bee.x > 30 && bee.x < 890) {
                bee.x = bee.x - 5;
            };
        });

    let load = function() { // Define images
        sprites.bee = new Image ();
        sprites.bee.src = '../img/bees/bee_1.png';
        sprites.background = new Image ();
        sprites.background.src = '../img/bees/wall_1.webp';
        sprites.enemy = new Image ();
        sprites.enemy.src = '../img/bees/spider_1.png';
        sprites.goal = new Image ();
        sprites.goal.src = '../img/bees/flower.webp';
    };

    let addBee = () => {
        let beePlaceholder = document.getElementById('beesAvailable');
        let beeNode = document.createElement('span');
        let beeImage = '<img src="../img/bees/bee.webp" width="22" alt="Bee">';
        beeNode.innerHTML = beeImage;
        beePlaceholder.appendChild(beeNode);
    };

    let defaultBees;

    for (defaultBees = 1; defaultBees < maxAttempt; defaultBees++) {
        addBee();
    };

    let update = function() { //update position
        if (checkCollisionBee(bee, goal)) { // check if you won
            audioApi.src = '../audio/bees/success.mp3';

            let rounds = 5; // Success Rounds to Get New Bee
            let drop1 = document.getElementById('drop1');
            let drop2 = document.getElementById('drop2');
            let drop3 = document.getElementById('drop3');
            let drop4 = document.getElementById('drop4');

            let light = 'bi bi-droplet';
            let honey = 'bi bi-droplet-fill';

            if (level % rounds === 1) { // Show Honey Drops
                drop1.className = honey;
            } else if (level % rounds === 2) {
                drop2.className = honey;
            } else if (level % rounds === 3) {
                drop3.className = honey;
            } else if (level % rounds === 4) {
                drop4.className = honey;
            } else if (level % rounds === 0) {
                drop1.className = light;
                drop2.className = light;
                drop3.className = light;
                drop4.className = light;

                maxAttempt++;

                addBee();

                // Bee Speeds Up
                bee.speedX += 2;
            };

            level++; // increase level

            // Show Level
            document.getElementById('gameLevel').textContent = '';
            document.getElementById('gameLevel').textContent = level;

            // Show Max Attempt
            document.getElementById('maxAttempt').textContent = '';
            document.getElementById('maxAttempt').textContent = maxAttempt;

            // Change the bees, spiders and walls based on level
            if (level > 2 && level <= 4) {
                sprites.bee.src = '../img/bees/bee_2.png';
                sprites.enemy.src = '../img/bees/spider_2.png';
                sprites.background.src = '../img/bees/wall_2.webp';
            } else if (level > 4) {
                sprites.bee.src = '../img/bees/bee_3.png';
                sprites.enemy.src = '../img/bees/spider_3.png';
                sprites.background.src = '../img/bees/wall_3.webp';
            }

            bee.x = 30; // return bee to starting point
            bee.y = 240;

            stopBee();

            resetKeys = true;

            spiders.forEach(function(element) { // increase speed of spiders
                if (element.speedY > 0) {
                    element.speedY++;
                } else {
                    element.speedY--;
                }
            });
        }

        // update bee
        if (bee.isMoving) {
            bee.x += bee.speedX;
        };

        // update spiders
        spiders.forEach(function(element) {
            if (checkCollision(bee, element)) { // Check for collision with bee
                if (attempt < maxAttempt) { // lost a bee, but still playing
                    audioApi.src = '../audio/bees/click.mp3';

                    attempt++; // increase attempt

                    $('#beesNotificationBody').text(`${lang.getting_bee} ${attempt} ${lang.of} ${maxAttempt}.`);
                    $('#beesNotification').toast('show');

                    color.className = ''; // Remove color

                    if (attempt >= 2 && attempt < maxAttempt) { // Change colors
                        color.className = 'orange';
                    } else if (attempt === maxAttempt) {
                        color.className = 'red';
                    }

                    document.getElementById('attempt').textContent = ''; // Remove Attempt Number
                    document.getElementById('attempt').textContent = attempt; // Add New Attempt Number

                    bee.x = 30; // return bee to starting point
                    bee.y = 240;

                    gameLive = true;
                    stopBee();

                    resetKeys = true;

                    // Remove Bee
                    let beesLeft = maxAttempt - attempt;
                    document.getElementById('beesAvailable').innerHTML = '';
                    let drawingBees;
                    for (drawingBees = 1; drawingBees <= beesLeft; drawingBees++) {
                        addBee();
                    }
                } else {
                    resultCounter++;
                    localStorage.setItem('result_counter', resultCounter);

                    let thisDate = new Date();

                    let year = thisDate.getFullYear();
                    let month = thisDate.getMonth() + 1;
                    let day = thisDate.getDate();

                    let results = {
                        number: resultCounter,
                        level: level,
                        bees: maxAttempt,
                        date: `${month}/${day}/${year} - ${formatAMPM(thisDate)}`
                    };

                    localStorage.setItem(`result_${resultCounter}`, JSON.stringify(results));

                    if (resultCounter == 1) {
                        $('#results-body').html('');
                    }

                    // Create Cookie for Highest Level
                    // setCookie(level);

                    gameLive = false; // Stop game

                    audioApi.src = '../audio/bees/bee.mp3';

                    $('#game-over-level').text(level);

                    $('#game-over-modal').modal('show');
                };
            };

            element.y += element.speedY;

            // Check borders
            if (element.y <= 10) {
                element.y = 10;
                //element.speedY = element.speedY * -1;
                element.speedY *= -1;
            } else if (element.y >= GAME_HEIGHT - 50) {
                element.y = GAME_HEIGHT - 50;
                element.speedY *= -1;
            };

        }); // end of forEach
    };

    let draw = function() { // show game
        ctx.clearRect(0, 0, GAME_WIDTH, GAME_HEIGHT); // clearn canvas
        // draw background
        ctx.drawImage(sprites.background, 0, 0);
        // draw spiders
        spiders.forEach(function (element) {
            ctx.drawImage (sprites.enemy, element.x, element.y);
        });
        // draw goal object
        ctx.drawImage(sprites.goal, goal.x, goal.y);
        // draw bee
        ctx.drawImage(sprites.bee, bee.x, bee.y);
    };

    // executed multiple times/second
    let step = function() {
        update();
        draw();

        if (gameLive) {
            window.requestAnimationFrame(step);
        };
    };

    let checkCollision = function(rect1, rect2) { // Check Collision
        let closeOnWidth = Math.abs(rect1.x - rect2.x) <= Math.max(rect1.w, rect2.w);
        let closeOnHeight = Math.abs(rect1.y - rect2.y) <= Math.max(rect1.h, rect2.h);

        return closeOnWidth && closeOnHeight;
    };

    let checkCollisionBee = function(rect1, rect2) { // Check Collision between bee and flower
        let closeOnWidthBee = Math.abs((rect1.x - rect2.x) - 90) <= Math.max(rect1.w, rect2.w);
        let closeOnHeightBee = Math.abs((rect1.y - rect2.y) - 90) <= Math.max(rect1.h, rect2.h);
        // Adding -90 makes bee land exactly on top of flower instead of just touching its edges.

        return closeOnWidthBee && closeOnHeightBee;
    };

    // kick start (re-)drawing and (re-)cleaning
    load(); // Load images
    step();

    $('#game-over-modal').on('hidden.bs.modal', function(e) {
        window.location = '';
    });
}); // end of 'load' event
